import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';

import GetUpdatesCheckbox from '../Widget/GetUpdatesCheckbox';

import ReactGoogleAutocomplete from '../InputFields/GoogleMapsAddressField';
import InputGroup from '../InputGroup';
import Button from '../Button';
import TwoGroup from '../TwoGroup';
import DropDownSelect from '../DropDownSelect';
import { LoadingSpinner } from '../../components/LoadingSpinner';

import {
    ButtonGroupWrapper,
    Container,
    GroupLabel,
    MultipleGroupFirstMed,
    MultipleGroupFull,
    MultipleGroupLast,
    OnSubmitValidator,
    OptIns,
    CheckboxWrapper,
    RemindersNotice
} from '../../containers/DefaultStyles/FormDetails';

import { getCachedFirstName, getCachedLastName } from '../../utils/formCaching/helpers';
import submissionErrorHandler from '../../utils/submissionErrorHandler';
import {
    DayDropdownValues,
    MonthDropdownValues,
    YearDropdownValues,
    StatesId
} from '../../utils/enums';
import validate from './validations';
import { copyFor, capitalization } from '../../copy/copy';
import { isPortrait } from '../../utils/size';

class CheckRegistrationForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            valid: false,
            errors: submissionErrorHandler(props.currentFormValues, validate)
        };
        this.clearSubmitErrors = this.clearSubmitErrors.bind(this);
        this.setValidState = this.setValidState.bind(this);
    }

    componentDidMount() {
        this.setState({ errors: [] });
    }

    setValidState(bool) {
        this.setState({ valid: bool });
    }

    setSubmitErrors(errors) {
        this.setState({ errors });
    }

    checkForBlurError(name) {
        const errors = submissionErrorHandler(this.props.currentFormValues, validate);
        if (errors.includes(name) && !this.state.errors.includes(name))
            this.setState({ errors: [...this.state.errors, name] });
    }

    clearSubmitErrors(fieldName) {
        if (fieldName && this.state.errors.includes(fieldName)) {
            this.setState({ errors: this.state.errors.filter(e => e !== fieldName) });
        }
    }

    render() {
        return (
            <Container
                noOverflow
                style={{ marginTop: `${isPortrait() ? `20px` : `0px`}` }}
                autocomplete="on"
                onSubmit={this.props.handleSubmit}
            >
                <MultipleGroupFull>
                    <Field
                        name="firstName"
                        onBlur={() => this.checkForBlurError('firstName')}
                        submissionError={this.state.errors.includes('firstName')}
                        clearSubmitErrors={this.clearSubmitErrors}
                        component={InputGroup}
                        type="text"
                        label="First name"
                        placeholder="First Name"
                        autocomplete="off"
                    />
                    <Field
                        name="lastName"
                        onBlur={() => this.checkForBlurError('lastName')}
                        submissionError={this.state.errors.includes('lastName')}
                        clearSubmitErrors={this.clearSubmitErrors}
                        component={InputGroup}
                        type="text"
                        label="Last name"
                        placeholder="Last Name"
                        autocomplete="off"
                    />
                </MultipleGroupFull>
                {!this.props.isMobileResolution && (
                    <MultipleGroupLast onBlur={() => this.checkForBlurError('address')}>
                        <ReactGoogleAutocomplete
                            submissionError={this.state.errors.includes('address')}
                            clearSubmitErrors={this.clearSubmitErrors}
                            formName={['checkRegistrationForm', 'google_autocomplete']}
                            fields={['address_components', 'formatted_address']}
                            types={['address']}
                            componentRestrictions={{ country: 'US' }}
                            setValidState={this.setValidState}
                        />
                    </MultipleGroupLast>
                )}
                {this.props.isMobileResolution && (
                    <MultipleGroupFull onBlur={() => this.checkForBlurError('address')}>
                        <ReactGoogleAutocomplete
                            submissionError={this.state.errors.includes('address')}
                            clearSubmitErrors={this.clearSubmitErrors}
                            formName={['checkRegistrationForm', 'google_autocomplete']}
                            fields={['address_components', 'formatted_address']}
                            types={['address']}
                            componentRestrictions={{ country: 'US' }}
                            setValidState={this.setValidState}
                        />
                    </MultipleGroupFull>
                )}
                <MultipleGroupFirstMed
                    style={{
                        position: 'relative',
                        paddingTop: '14px'
                    }}
                >
                    <GroupLabel
                        style={{
                            position: 'absolute',
                            left: `15px`,
                            top: '0px'
                        }}
                    >
                        {'Date of Birth'}
                    </GroupLabel>
                    <Field
                        onBlur={() => this.checkForBlurError('month')}
                        submissionError={this.state.errors.includes('month')}
                        clearSubmitErrors={this.clearSubmitErrors}
                        name="month"
                        component={DropDownSelect}
                        options={this.props.month}
                        label="Month"
                        type="text"
                    />
                    <Field
                        onBlur={() => this.checkForBlurError('day')}
                        submissionError={this.state.errors.includes('day')}
                        clearSubmitErrors={this.clearSubmitErrors}
                        name="day"
                        component={DropDownSelect}
                        options={this.props.day}
                        label="Day"
                        type="text"
                    />
                    <Field
                        onBlur={() => this.checkForBlurError('year')}
                        submissionError={this.state.errors.includes('year')}
                        clearSubmitErrors={this.clearSubmitErrors}
                        name="year"
                        component={DropDownSelect}
                        options={this.props.year}
                        label="Year"
                        type="text"
                    />
                </MultipleGroupFirstMed>
                <MultipleGroupLast>
                    <Field
                        onBlur={() => this.checkForBlurError('email')}
                        submissionError={this.state.errors.includes('email')}
                        clearSubmitErrors={this.clearSubmitErrors}
                        name="email"
                        component={InputGroup}
                        type="email"
                        label="Email"
                        placeholder="Email"
                        autocomplete="off"
                    />
                </MultipleGroupLast>
                {(this.props.hasPartnerOptIn || this.props.hasABOptIn) && (
                    <OptIns>
                        <RemindersNotice>
                            {!!this.props.subscriptionOptInText
                                ? this.props.subscriptionOptInText
                                : this.props.endUserLocation.isEU
                                ? copyFor('formFields', 'updatesMultipleEU')
                                : copyFor(
                                      'formFields',
                                      'updatesEmail',
                                      undefined,
                                      capitalization.eachWord
                                  )}
                        </RemindersNotice>
                        <CheckboxWrapper>
                            {this.props.hasPartnerOptIn && (
                                <GetUpdatesCheckbox
                                    name={'hasPartnerOptIn'}
                                    style={{
                                        padding: `${isPortrait() ? `2px 0` : `0`}`
                                    }}
                                    labelText={this.props.partnerOptInText}
                                    defaultChecked={!this.props.endUserLocation.isEU}
                                    isEU={this.props.endUserLocation.isEU}
                                />
                            )}
                            {this.props.hasABOptIn && (
                                <GetUpdatesCheckbox
                                    style={{ paddingTop: 0, paddingBottom: '5px' }}
                                    isEU={this.props.endUserLocation.isEU}
                                    defaultChecked={!this.props.endUserLocation.isEU}
                                    labelText={'Action Button'}
                                />
                            )}
                        </CheckboxWrapper>
                    </OptIns>
                )}
                <ButtonGroupWrapper
                    style={{ position: isPortrait() ? 'static' : 'absolute ' }}
                    isFormSubmitting={this.props.isFormSubmitting}
                    rightPosition={23}
                >
                    <TwoGroup>
                        <Button label="Back" onClick={this.props.onBack} />
                        <OnSubmitValidator
                            onClick={e => {
                                e.preventDefault();
                                const errors = submissionErrorHandler(
                                    this.props.currentFormValues,
                                    validate
                                );

                                if (errors.length === 0 && !this.props.invalid && this.state.valid) {
                                    this.props.handleSubmit();
                                } else {
                                    this.setSubmitErrors(errors);
                                }
                            }}
                        >
                            <Button
                                primary={true}
                                type="submit"
                                label="Continue"
                                className="submitButton"
                                disabled={this.props.invalid || !this.state.valid}
                                isSubmitting={this.props.isFormSubmitting}
                            />
                        </OnSubmitValidator>
                        <LoadingSpinner />
                    </TwoGroup>
                </ButtonGroupWrapper>
            </Container>
        );
    }
}

CheckRegistrationForm.propTypes = {
    currentFormValues: PropTypes.object,
    day: PropTypes.array.isRequired,
    endUserLocation: PropTypes.object.isRequired,
    handleSubmit: PropTypes.func,
    hasABOptIn: PropTypes.bool.isRequired,
    hasPartnerOptIn: PropTypes.bool.isRequired,
    invalid: PropTypes.bool.isRequired,
    isFormSubmitting: PropTypes.bool,
    isMobileResolution: PropTypes.bool.isRequired,
    month: PropTypes.array.isRequired,
    onBack: PropTypes.func,
    partnerOptInText: PropTypes.string,
    subscriptionOptInText: PropTypes.string,
    year: PropTypes.array.isRequired
};

export default compose(
    connect((state, props) => {
        const initialValues = {
            address:
                state.cachedFormData.homeAddress || state.cachedFormData.address || '',
            day: state.cachedFormData.day || '',
            email: state.cachedFormData.email || '',
            firstName: getCachedFirstName(state),
            getUpdates: !(state.widget.endUserLocation || {}).isEU && props.hasABOptIn,
            lastName: getCachedLastName(state),
            month: state.cachedFormData.month || '',
            stateId: state.cachedFormData.stateId || '',
            year: state.cachedFormData.year || ''
        };

        if (props.hasPartnerOptIn) {
            initialValues.hasPartnerOptIn = !(state.widget.endUserLocation || {}).isEU;
        }
        return {
            initialValues,
            day: DayDropdownValues(),
            month: MonthDropdownValues,
            year: YearDropdownValues(),
            states: StatesId,
            isMobileResolution: state.widget.isMobileResolution,
            endUserLocation: state.widget.endUserLocation || {},
            currentFormValues: (state.form['checkRegistrationForm'] || {}).values
        };
    }),
    reduxForm({
        form: 'checkRegistrationForm',
        destroyOnUnmount: false,
        validate
    })
)(CheckRegistrationForm);
